import React, { useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import PageTitle from '../components/PageTitle';
import axios from 'axios';
import { API_URL } from '../config';

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [show, setShow] = useState(false);
  const [error, setError] = useState('');
  const [ok, setOk] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    const passwordPolicy =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{8,}$/;

    if (!token) return setError('Invalid or missing reset token in URL.');
    if (!passwordPolicy.test(password)) {
      return setError(
        'Password must be at least 8 characters and include uppercase, lowercase, number, and special character.'
      );
    }
    if (password !== confirm) return setError('Passwords do not match.');

    setLoading(true);
    try {
      await axios.post(`${API_URL}/auth/reset-password`, { token, password });
      setOk(true);
      setTimeout(() => navigate('/login'), 1200);
    } catch (err) {
      const msg =
        err?.response?.data?.error ||
        err?.response?.data?.message ||
        'Reset link is invalid or expired.';
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="landing-wrapper">
      <PageTitle title="Reset Password" noIndex canonical="https://markazsync.com/reset-password" />
      <div className="landing-box">
        <h2>Set a new password</h2>

        {ok ? (
          <p>Password updated. Redirecting to login…</p>
        ) : (
          <>
            {!token && (
              <div className="error-message" style={{ marginBottom: 12 }}>
                Invalid or missing reset token. Please request a new link.
              </div>
            )}

            <form onSubmit={handleSubmit} className="login-form">
              <p className="password-hint">
                Password must be at least 8 characters and include uppercase, lowercase, number, and
                special character.
              </p>
              <p className="password-example">Example: Example@2024</p>
              <div className="password-field">
                <input
                  type={show ? 'text' : 'password'}
                  placeholder="New password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  autoComplete="new-password"
                />
                <button
                  type="button"
                  className="toggle-password"
                  onClick={() => setShow((s) => !s)}
                  aria-label={show ? 'Hide password' : 'Show password'}
                  aria-pressed={show}
                >
                  <i className={`bi ${show ? 'bi-eye-slash' : 'bi-eye'}`} aria-hidden="true" />
                </button>
              </div>

              <input
                type={show ? 'text' : 'password'}
                placeholder="Confirm new password"
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
                required
                autoComplete="new-password"
              />

              {error && <div className="error-message">{error}</div>}

              <button type="submit" disabled={loading || !token}>
                {loading ? 'Updating…' : 'Update password'}
              </button>
            </form>

            <div style={{ marginTop: 12 }}>
              <Link to="/forgot-password">Request a new reset link</Link>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPassword;
